import React, { useContext } from 'react';
import { FeatureToggleContext } from '@/context/featureToggleContext';

export const useFeatureToggle = () => {
  const { featureFlags: enabledFeatures } = useContext(FeatureToggleContext);

  const isFeatureEnabled = (featureName: string) => {
    return !!enabledFeatures[featureName];
  };

  return [isFeatureEnabled];
};
